export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** DateTime */
  DateTimeUtc: any;
};

export type AuthResponse = InitiateAuthResponse | TokensResponse;

export type AutoDebitSettlement = {
  __typename?: 'AutoDebitSettlement';
  pullAmount: Scalars['Float'];
  pullDate?: Maybe<Scalars['DateTimeUtc']>;
  pullStatus: AutoDebitSettlementStatus;
  resultsProcessedBy: Scalars['DateTimeUtc'];
};

export enum AutoDebitSettlementStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
}

export type BillStatement = {
  __typename?: 'BillStatement';
  amount: Scalars['Float'];
  autoDebitSettlement?: Maybe<AutoDebitSettlement>;
  bankTransferSettlementAvailable: Scalars['Boolean'];
  combiniSettlementAvailable: Scalars['Boolean'];
  currency: Currency;
  dueAt: Scalars['DateTimeUtc'];
  id: Scalars['String'];
  lateFeeAmount: Scalars['Float'];
  outstandingAmount: Scalars['Float'];
  paidAt?: Maybe<Scalars['DateTimeUtc']>;
  period: Period;
  spentAmount?: Maybe<Scalars['Float']>;
  status: BillStatementStatus;
  totalCredits: Scalars['Float'];
  unpaidAmount: Scalars['Float'];
  unpaidAmountActual: Scalars['Float'];
};

export enum BillStatementStatus {
  CREATED = 'CREATED',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
}

export type Code = {
  __typename?: 'Code';
  consumerCode: Scalars['String'];
  merchantCode: Scalars['String'];
  store: Scalars['String'];
};

export enum Currency {
  JPY = 'JPY',
  USD = 'USD',
}

export type InitiateAuthResponse = {
  __typename?: 'InitiateAuthResponse';
  session: Scalars['String'];
};

export type MinimumAppVersion = {
  __typename?: 'MinimumAppVersion';
  android: Scalars['String'];
  ios: Scalars['String'];
};

export type MutationPublic = {
  __typename?: 'MutationPublic';
  /** Change a consumer's phone */
  changePhone: Scalars['Boolean'];
  /** Confirm unauthenticated phone number reset */
  confirmResetPhoneNumberPublic: Scalars['Boolean'];
  /** Confirm a consumer's token */
  confirmToken: Token;
  /** Conclude unauthenticated phone number reset */
  doResetPhoneNumberPublic: Scalars['Boolean'];
  /** Impersonate an authentication */
  impersonate: Token;
  /** Initiate authentication with Cognito */
  initiateAuth: InitiateAuthResponse;
  /** Initiates email reminder flow */
  initiateMyEmailReminder: Scalars['String'];
  /** Initiate unauthenticated phone number reset flow */
  initiateResetPhoneNumberPublic: Scalars['Boolean'];
  /** Refresh tokens with Cognito */
  refreshAuth: TokensResponse;
  /** Request a token for a consumer */
  requestToken: Token;
  /** Request a token for an Android consumer */
  requestTokenAndroid: Token;
  /** Request a token for an iOS consumer */
  requestTokenIos: Token;
  /** Respond to authentication challenge with Cognito */
  respondToAuthChallenge: AuthResponse;
  /** Challenge response to email reminder flow */
  respondToMyEmailReminderChallenge?: Maybe<Scalars['String']>;
};

export type MutationPublicchangePhoneArgs = {
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type MutationPublicconfirmResetPhoneNumberPublicArgs = {
  currentPhoneNumber: Scalars['String'];
  email: Scalars['String'];
  newPhoneNumber: Scalars['String'];
  otp: Scalars['String'];
  pinCodeDispatchMethod?: InputMaybe<PinCodeDispatchMethod>;
  recaptchaPlatform: Platform;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicconfirmTokenArgs = {
  pinCode: Scalars['String'];
  token: Scalars['String'];
};

export type MutationPublicdoResetPhoneNumberPublicArgs = {
  currentPhoneNumber: Scalars['String'];
  email: Scalars['String'];
  otp: Scalars['String'];
  recaptchaPlatform: Platform;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicimpersonateArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type MutationPublicinitiateAuthArgs = {
  email: Scalars['String'];
  phone: Scalars['String'];
  pinCodeDispatchMethod: PinCodeDispatchMethod;
  recaptchaPlatform: Platform;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicinitiateMyEmailReminderArgs = {
  phoneNumber: Scalars['String'];
  pinCodeDispatchMethod: PinCodeDispatchMethod;
  recaptchaPlatform: Platform;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicinitiateResetPhoneNumberPublicArgs = {
  currentPhoneNumber: Scalars['String'];
  email: Scalars['String'];
  recaptchaPlatform: Platform;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicrefreshAuthArgs = {
  refreshToken: Scalars['String'];
};

export type MutationPublicrequestTokenArgs = {
  email: Scalars['String'];
  phone: Scalars['String'];
  pinCodeDispatchMethod: PinCodeDispatchMethod;
};

export type MutationPublicrequestTokenAndroidArgs = {
  email: Scalars['String'];
  phone: Scalars['String'];
  pinCodeDispatchMethod: PinCodeDispatchMethod;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicrequestTokenIosArgs = {
  email: Scalars['String'];
  phone: Scalars['String'];
  pinCodeDispatchMethod: PinCodeDispatchMethod;
  recaptchaToken: Scalars['String'];
};

export type MutationPublicrespondToAuthChallengeArgs = {
  answer: Scalars['String'];
  session: Scalars['String'];
};

export type MutationPublicrespondToMyEmailReminderChallengeArgs = {
  answer: Scalars['String'];
  recaptchaPlatform: Platform;
  recaptchaToken: Scalars['String'];
  session: Scalars['String'];
};

export type PaygentSettlement = {
  __typename?: 'PaygentSettlement';
  amount: Scalars['Float'];
  codes: Code;
  currency: Currency;
  settlementFeeAmount?: Maybe<Scalars['Float']>;
};

export type Period = {
  __typename?: 'Period';
  end: Scalars['DateTimeUtc'];
  start: Scalars['DateTimeUtc'];
};

export enum PinCodeDispatchMethod {
  SMS = 'SMS',
  VOICE = 'VOICE',
}

/** Platform from which the request was made */
export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
}

export enum PublicFeatureState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type PublicFeatures = {
  __typename?: 'PublicFeatures';
  adrsOverdueBillAlternativeSettlementMethod: PublicFeatureState;
};

export type PublicUnpaidBillStatement = {
  __typename?: 'PublicUnpaidBillStatement';
  bankTransferSettlementAvailable: Scalars['Boolean'];
  combiniSettlementAvailable: Scalars['Boolean'];
  dueAt: Scalars['String'];
  id: Scalars['String'];
  lateFeeAmount: Scalars['Float'];
  outstandingAmount: Scalars['Float'];
  status: PublicUnpaidBillStatus;
  unpaidAmount: Scalars['Float'];
};

export type PublicUnpaidBillStatements = {
  __typename?: 'PublicUnpaidBillStatements';
  billStatements: Array<PublicUnpaidBillStatement>;
};

export enum PublicUnpaidBillStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  OUTSTANDING = 'OUTSTANDING',
  OVERDUE = 'OVERDUE',
  PAID = 'PAID',
}

export type QueryPublic = {
  __typename?: 'QueryPublic';
  /** Get a bank settlement by Paidy code */
  bankSettlement: VAN;
  /** Get a bill statement by Paidy code */
  billStatement: BillStatement;
  /** Generate a combini settlement by Paidy code */
  combiniSettlement: PaygentSettlement;
  createSinglebillNumericCodeV3: PaygentSettlement;
  /** Return the minimum supported app version */
  minimumSupportedVersion: MinimumAppVersion;
  /** Return the state of publicly available features */
  publicFeatures: PublicFeatures;
  /** Get all unpaid bill statements from a consumer by Paidy code */
  unpaidBillStatements: PublicUnpaidBillStatements;
};

export type QueryPublicbankSettlementArgs = {
  paidyCode: Scalars['String'];
};

export type QueryPublicbillStatementArgs = {
  paidyCode: Scalars['String'];
};

export type QueryPubliccombiniSettlementArgs = {
  isFamilyMart?: InputMaybe<Scalars['Boolean']>;
  paidyCode: Scalars['String'];
};

export type QueryPubliccreateSinglebillNumericCodeV3Args = {
  billId: Scalars['String'];
  cvsStoreId: Scalars['String'];
};

export type QueryPublicunpaidBillStatementsArgs = {
  paidyCode: Scalars['String'];
};

export type Token = {
  __typename?: 'Token';
  sessionToken: Scalars['String'];
  status: TokenStatus;
};

export enum TokenStatus {
  CONFIRMED = 'CONFIRMED',
  CREATED = 'CREATED',
}

export type TokensResponse = {
  __typename?: 'TokensResponse';
  accessToken: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
};

export type VAN = {
  __typename?: 'VAN';
  accountHolder: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  branchName: Scalars['String'];
};
